import React from "react";
import "./Home.css";
import Header from "../Header/Header";
import { useLoaderData } from "react-router-dom";
import Course from "../Course/Course";

const Home = () => {
  const loadData = useLoaderData();
  const courses = loadData.data;
  console.log(courses);
  return (
    <div>
      <Header></Header>
      <div className="home-container mx-md-4 my-md-5 mx-2 my-4 row row-cols-1 row-cols-md-2 row-cols-lg-4 d-flex justify-content-center">
        {courses?.map((course) => (
          <Course course={course} key={course.id}></Course>
        ))}
      </div>
    </div>
  );
};

export default Home;
